import { lazy } from "react";
import { Route } from "react-router";
import { Navigate } from "react-router-dom";
import AdminChangePassword from "../adminAuth/changePassword/changePassword";
import AdminForgotPassword from "../adminAuth/forgotPassword/forgotPassword";
import AdminLogin from "../adminAuth/login/login";
import AdminResetPassword from "../adminAuth/resetPassword/resetPassword";
import AdminResetPasswordSuccess from "../adminAuth/resetPasswordSuccess/resetPasswordSuccess";
import AdminTwoStepVerification from "../adminAuth/twoStepVerification/twoStepVerification";
import AdminVerifyOtp from "../adminAuth/verifyOtp/verifyOtp";
import AdminSettings from "../pages/adminSettings";
import { all_routes } from "./all_routes"; // Updated SQ paths

import ChangePassword from "../auth/changePassword/changePassword";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import EmployeeLogin from "../auth/login/employeeLogin";
import Register from "../auth/register/register";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import VerifyOtp from "../auth/verifyOtp/verifyOtp";
import FindAllDepartment from "../pages/adminDepartment";
import FindAllDesignations from "../pages/adminDesignation";

import AttendanceSummary from "../pages/attendance/attendanceSummary";

import AnnouncementList from "../pages/announcements";
import EAttestationMaster from "../pages/eAttestation/EAttestationMaster";
import EAttestationApprover from "../pages/eAttestation/EAttestationApprover";
import EAttestationList from "../pages/eAttestation/EAttestationList";
import EAttestationForm from "../pages/eAttestation/EAttestationForm";
import EAttestationDetails from "../pages/eAttestation/EAttestationDetails";

import Intent from "../pages/chatbot";
import ChatInterface from "../pages/chatbot/ChatInterface";
import EmailTemplates from "../pages/emailTemplates";
import EmployeeProfile from "../pages/employeeProfile/index";
import Esepration from "../pages/eSepration/Esepration";
import EmployeesList from "../pages/employees/index";
import StaffQuarterRequests from "../pages/staffQuarter/requests/EmployeeRequestList";
import NewRegistration from "../pages/staffQuarter/requests/NewRegistration";
import OccupationWithdrawal from "../pages/staffQuarter/operations/OccupationWithdrawal";
import VacationIntimation from "../pages/staffQuarter/operations/VacationIntimation";
import VacationIntimationForm from "../pages/staffQuarter/operations/VacationIntimationForm";
import MyAllotments from "../pages/staffQuarter/requests/MyAllotments";
import EmployeePriorityList from "../pages/staffQuarter/requests/EmployeePriorityList"; // Forced recompile comment
import Unwillingness from "../pages/staffQuarter/requests/Unwillingness";
import StaffQuarterDetails from "../pages/staffQuarter/requests/PublicDetails";
import AdminOverview from "../pages/staffQuarter/dashboards/AdminOverview";
import AdminRequests from "../pages/staffQuarter/requests/AdminRequestList";
import StaffQuarterRequestDetails from "../pages/staffQuarter/requests/RequestDetails";
import HouseInventory from "../pages/staffQuarter/inventory/HouseInventory";
import PriorityList from "../pages/staffQuarter/operations/PriorityList";
import COOverview from "../pages/staffQuarter/dashboards/COOverview";
import Reports from "../pages/staffQuarter/reports_module/Reports";
import WillingnessInvitedReport from "../pages/staffQuarter/reports_module/WillingnessInvitedReport";
import InventoryDashboard from "../pages/staffQuarter/inventory/InventoryDashboard";
import FlatMaster from "../pages/staffQuarter/inventory/FlatMaster";
import VacationInitiation from "../pages/staffQuarter/inventory/VacationInitiation";
import InventoryHistory from "../pages/staffQuarter/inventory/History";
import InventoryLocationBreakdown from "../pages/staffQuarter/inventory/InventoryLocationBreakdown";
import LocationFlatView from "../pages/staffQuarter/inventory/LocationFlatView";
import LetterTemplates from "../pages/staffQuarter/management/LetterTemplates";
import MutualExchange from "../pages/staffQuarter/management/MutualExchange";
import AdminMutualExchange from "../pages/staffQuarter/management/AdminMutualExchange";
import PostPromotion from "../pages/postPromotion/PostPromotion";
import PromotionList from "../pages/postPromotion/promotionList";
import DpcApprovalList from "../pages/postPromotion/dpcApprovalList";
import DpcReview from "../pages/postPromotion/dpcReview";
import ProbationConfirmation from "../pages/postPromotion/probationConfirmation";
import OfficeOrders from "../pages/postPromotion/officeOrders";
import SapSyncLog from "../pages/postPromotion/sapSyncLog";
import NewPromotionCycle from "../pages/postPromotion/newPromotionCycle";

// Probation Pages
import ProbationDashboard from "../pages/probation/ProbationDashboard";
import NewProbationCycle from "../pages/probation/NewProbationCycle";
import ProbationCandidatesList from "../pages/probation/ProbationCandidatesList";
import ProbationCommitteeReview from "../pages/probation/ProbationCommitteeReview";
import ProbationApprovalList from "../pages/probation/ProbationApprovalList";
import ProbationOfficeOrders from "../pages/probation/ProbationOfficeOrders";
import Overview from "../pages/staffQuarter/dashboards/EmployeeDashboard";
import EmployeesAttendanceList from "../pages/employeesAttendance";
import LeaveManagment from "../pages/employeesLeaves";
import CreateLeaveRequest from "../pages/employeesLeaves/CreateLeaveRequest";
import LeaveDetailsPage from "../pages/employeesLeaves/LeaveDetailsPage";
import Services from "../pages/employeesServices";
import Error404 from "../pages/error/error-404";
import HolidaysCalendar from "../pages/holidaysCalendar/index";
import LanguageList from "../pages/language";
import LoginLogs from "../pages/loginLogs";
import AddMasterBeacon from "../pages/masterBeacon/add";
import MasterBeaconList from "../pages/masterBeacon/index";
import MyProfile from "../pages/myProfile/myProfile";
import AdminProfile from "../pages/adminProfile/adminProfile";
import Notification from "../pages/notification/index";
import AddOfficeLocation from "../pages/officeLocation/add";
import OfficeLocationsList from "../pages/officeLocation/index";
import ReportingAttendence from "../pages/reportingAttendence";
import ReportingEmployees from "../pages/reportingEmployees/index";
import ReportingEmployeesDailyAttendence from "../pages/reportingEmployeesDailyAttendence";
import ReportingShift from "../pages/reportingShift";
import ErrorList from "../pages/settings/errorList";
import GlobalSettings from "../pages/settings/global";
import LanguageSettings from "../pages/settings/language";
import LeaveType from "../pages/settings/Leave/leaveType";
import OutsideJobNature from "../pages/settings/Leave/outsideJobNature";
import PusherSettings from "../pages/settings/pusher";
import RecaptchaSettings from "../pages/settings/recaptcha";
import SMSSettings from "../pages/settings/sms";
import StorageSettings from "../pages/settings/storage";
import EsepHrWingSettings from "../pages/settings/esepHrWing";
import EsepHrLevelConfigSettings from "../pages/settings/esepHrLevelConfig";
import StaffQuarterApprovalSettings from "../pages/settings/staffQuarterApproval";
import ChangeCurrentApprover from "../pages/staffQuarter/management/ChangeCurrentApprover";
import ShiftVerificationList from "../pages/shiftVerifications";
import SMSTemplates from "../pages/smsTemplates";
import TeamShiftHistory from "../pages/teamShiftHistory";
import RolesPermissions from "../pages/user-management/rolesPermissions";
import WorkShifts from "../pages/workShifts/index";

// NOC Pages
import ForeignVisitCreate from "../pages/noc/foreign-visit-create";
import NOCForeignVisit from "../pages/noc/foreignVisit";
import ForeignVisitDetails from "../pages/noc/foreignVisitDetails";
import NOCHigherEducation from "../pages/noc/higherEducation";
import NOCHigherEducationDetails from "../pages/noc/higherEducationDetails";
import NOCMain from "../pages/noc/index";
import NOCHigherStudiesForm from "../pages/noc/nocHigherStudiesForm";
import NOCOnlineCourse from "../pages/noc/onlineCourse";
import NOCOnlineCourseCreate from "../pages/noc/onlineCourseCreate";
import NOCOnlineCourseDetails from "../pages/noc/onlineCourseDetails";
import NOCOnlineCourseReimbursement from "../pages/noc/onlineCourseReimbursement";
import NOCOnlineCourseReimbursementDetails from "../pages/noc/onlineCourseReimbursementDetails";
import NOCOutsideJob from "../pages/noc/outsideJob";
import NOCOutsideJobCreateForm from "../pages/noc/outsideJobCreateForm";
import NOCOutsideJobDetails from "../pages/noc/outsideJobDetails";
import NOCPassport from "../pages/noc/passport";
import PassportCreate from "../pages/noc/passport-create";
import NOCPassportDetails from "../pages/noc/passportDetails";

// Universal Worklist
import UniversalWorklist from "../pages/universalWorklist/index";
import AlertsPage from "../pages/universalWorklist/AlertsPage";
import LeaveApprovalDetailPage from "../pages/universalWorklist/LeaveApprovalDetailPage";
import LeaveApprovalPage from "../pages/universalWorklist/LeaveApprovalPage";
import NOCApprovalDetailPage from "../pages/universalWorklist/NOCApprovalDetailPage";
import ReimbursementApprovalDetailPage from "../pages/universalWorklist/ReimbursementApprovalDetailPage";
import ITDeclarationApprovalDetailPage from "../pages/universalWorklist/ITDeclarationApprovalDetailPage";
import ITDeclarationList from "../pages/itDeclaration/ITDeclarationList";
import ITDeclarationCreatePage from "../pages/itDeclaration/ITDeclarationCreatePage";
import ITDeclarationDetailsPage from "../pages/itDeclaration/ITDeclarationDetailsPage";
import NotificationsPage from "../pages/universalWorklist/NotificationsPage";
import OfficeMailsPage from "../pages/universalWorklist/OfficeMailsPage";
import TaskDetailsPage from "../pages/universalWorklist/TaskDetailsPage";
import TasksPage from "../pages/universalWorklist/TasksPage";
import TasksPageMobile from "../pages/universalWorklist/TasksPageMobile";
import ToDoWorklistMain from "../pages/universalWorklist/ToDoWorklistMain";
import TrackingPage from "../pages/universalWorklist/TrackingPage";

import LanguagePhrasePage from "../pages/language/LanguagePhrasePage";

import DMRCCalendar from "../pages/dmrcCalendar";
import AdminUsersList from "../pages/adminUsers";
import CircularsPage from "../pages/circulars";
import EmployeesDailyAttendance from "../pages/dailyAttendance";
import EmployeeAttendenceRegularize from "../pages/employeeAttendenceRegularize";
import EmployeeFaceVerificationList from "../pages/employeeFaceVerification";
import ProfileReasons from "../pages/employees/profile_reasons";
import SettingsPage from "../pages/employeeSetting";
import EmployeesVerificationList from "../pages/employeesVerifications";
import EmployeeWorkSchedule from "../pages/employeeWorkSchedule";
import FaceVerificationList from "../pages/FaceVerification";
import CasteMaster from "../pages/masters/caste";
import CourseCategoriesMaster from "../pages/masters/courseCategories";
import CourseDepartment from "../pages/masters/courseDepartment";
import CourseTypesMaster from "../pages/masters/courseTypes";
import DnrList from "../pages/masters/dnr";
import DocUploadTypesMaster from "../pages/masters/docUploadTypes";
import JobNatures from "../pages/masters/jobNatures";
import ModesOfCourseMaster from "../pages/masters/modesOfCourse";
import NocTravelMaster from "../pages/masters/nocTravel";
import SapMasterStatus from "../pages/masters/sapStatuses";
import StayMaster from "../pages/masters/sapStay";
import WingDesignationDepartment from "../pages/masters/wingDesignationDepartment";
import AnnualPropertyReturn from "../pages/otherServices/annualPropertyReturn";
import DueDrawn from "../pages/otherServices/dueDrawn";
import MultipleSalaryStatement from "../pages/otherServices/multipleSalaryStatement";
import PoliceVerification from "../pages/otherServices/policeVerification";
import ManagerSelfService from "../pages/otherServices/managerSelfService";
import AdminManagerSelfService from "../pages/otherServices/managerSelfService/AdminManagerSelfService";
import DisplayTaxCard from "../pages/otherServices/displayTaxCard";
import TaxSimplifier from "../pages/otherServices/taxSimplifier";
import TaxSimplifierDetails from "../pages/otherServices/taxSimplifier/TaxDetails";
import TaxDeclarationEdit from "../pages/otherServices/taxSimplifier/TaxDeclarationEdit";
import LoanSuretySelection, { LoanSuretyStatus } from "../pages/otherServices/loanSurety";
import AnnualNps from "../pages/otherServices/annualNps";
import AnnualPf from "../pages/otherServices/annualPf";
import SalaryStatement from "../pages/otherServices/salaryStatement";
import SalaryStatementEnglish from "../pages/otherServices/salaryStatementEnglish";
import SalaryStatementHindi from "../pages/otherServices/salaryStatementHindi";
import VPFContributionModule from "../pages/otherServices/vpfContribution";
import VpfDisplay from "../pages/otherServices/vpfContribution/VpfDisplay";
import AppealContributionList from "../pages/otherServices/appealContribution";
import CreateAppealContribution from "../pages/otherServices/appealContribution/CreateAppealContribution";
import AppealContributionDetails from "../pages/otherServices/appealContribution/AppealContributionDetails";
import LeaveEncashmentList from "../pages/otherServices/leaveEncashment/index";
import CreateLeaveEncashment from "../pages/otherServices/leaveEncashment/CreateLeaveEncashment";
import ReviewLeaveEncashment from "../pages/otherServices/leaveEncashment/ReviewLeaveEncashment";
import LeaveEncashmentDetail from "../pages/otherServices/leaveEncashment/LeaveEncashmentDetail";
import CommunityHallList from "../pages/otherServices/communityHall";
import CreateCommunityHallBooking from "../pages/otherServices/communityHall/CreateCommunityHallBooking";
import ViewCommunityHallBooking from "../pages/otherServices/communityHall/ViewCommunityHallBooking";
import CommunityHallBookingOverview from "../pages/otherServices/communityHall/CommunityHallBookingOverview";
import MedicalAttendanceList from "../pages/otherServices/medicalAttendance/index";
import CreateMedicalAttendance from "../pages/otherServices/medicalAttendance/CreateMedicalAttendance";
import ViewMedicalAttendance from "../pages/otherServices/medicalAttendance/ViewMedicalAttendance";
import DisplayMedicalAttendance from "../pages/otherServices/medicalAttendance/DisplayMedicalAttendance";
import AuthorityLetterList from "../pages/otherServices/authorityLetterHealthCheckup/index";
import CreateAuthorityLetter from "../pages/otherServices/authorityLetterHealthCheckup/CreateAuthorityLetter";
import ViewAuthorityLetter from "../pages/otherServices/authorityLetterHealthCheckup/ViewAuthorityLetter";
import DisplayAuthorityLetter from "../pages/otherServices/authorityLetterHealthCheckup/DisplayAuthorityLetter";
import StaffWelfareList from "../pages/otherServices/staffWelfareFund/index";
import CreateStaffWelfare from "../pages/otherServices/staffWelfareFund/CreateStaffWelfare";
import ViewStaffWelfare from "../pages/otherServices/staffWelfareFund/ViewStaffWelfare";
import OtpLogs from "../pages/otpLogs";
import WhoIsWho from "../pages/whoIsWho";
import WorkSchedule from "../pages/workSchedule";
import NocSapLogs from "../pages/nocSapLogs";
import HrmsApiLogs from "../pages/hrmsApiLogs";
import AuditLogs from "../pages/auditLogs";
import AdminActivityLogs from "../pages/adminActivityLogs";
import PrivacyPolicy from "../publicPages/privacyPolicy";
import OfficeLocationMap from "../publicPages/officeLocationMap"; // Forced rebuild comment
import UserManual from "../publicPages/userManual";
import IntroVideo from "../publicPages/introVideo";
import VpfList from "../pages/vpf";
import ReimbursementList from "../pages/reimbursement";
import IdCardList from "../pages/idCard";
import EOfficeList from "../pages/eOffice";
// DAR module pages
import DarDashboard from "../pages/dar/Dashboard";
import DarContemplated from "../pages/dar/DarContemplated";
import DarContemplatedList from "../pages/dar/DarContemplatedList";
import DarPending from "../pages/dar/DarPending";
import DarPendingList from "../pages/dar/DarPendingList";
import DarPendingView from "../pages/dar/DarPendingView";
import DarClosedList from "../pages/dar/DarClosedList";
import DarClosed from "../pages/dar/DarClosed";
import DarClosedView from "../pages/dar/DarClosedView";
import DarCaseView from "../pages/dar/DarCaseView";
import DarCasesTabbedList from "../pages/dar/DarCasesTabbedList";
import DarCaseDetailsDashboard from "../pages/dar/DarCaseDetailsDashboard";



// Reimbursement Pages (for employee routes)
import ReimbursementClaimsAdvances from "../pages/reimbursement/ReimbursementClaimsAdvances";
import ReimbursementListEmployee from "../pages/reimbursement/reimbursementList";
import ReimbursementCreationModal from "../pages/reimbursement/reimbursementCreationModal";
import InclusionParentsList from "../pages/dependentFamily/InclusionParentsList";
import InclusionParentsForm from "../pages/dependentFamily/InclusionParentsForm";
import DeletionParentsList from "../pages/dependentFamily/DeletionParentsList";
import DeletionParentsForm from "../pages/dependentFamily/DeletionParentsForm";
import FamilyMembersList from "../pages/dependentFamily/FamilyMembersList";
import FamilyMembersForm from "../pages/dependentFamily/FamilyMembersForm";
import InclusionApprovalPage from "../pages/dependentFamily/InclusionApprovalPage";
import IDCardInstruction from "../pages/IdCardManagement/IDCardInstruction";
import IDCardList from "../pages/IdCardManagement/IDCardList";
import IDCardForm from "../pages/IdCardManagement/IDCardForm";
import IDCardDetails from "../pages/IdCardManagement/IDCardDetails";
import IDCardApproval from "../pages/IdCardManagement/IDCardApproval";
// E-Requisition (IT) Pages
import ERequisitionITList from "../pages/ERequisitionIT/ERequisitionITList";
import ERequisitionITCreate from "../pages/ERequisitionIT/ERequisitionITCreate";
import ERequisitionITDetails from "../pages/ERequisitionIT/ERequisitionITDetails";
// SAP Authorization Pages
import SapAuthorizationList from "../pages/sapAuthorization/SapAuthorizationList";
import SapAuthorizationCreate from "../pages/sapAuthorization/SapAuthorizationCreate";
import SapAuthorizationDetails from "../pages/sapAuthorization/SapAuthorizationDetails";
import SapAuthorizationApproval from "../pages/sapAuthorization/SapAuthorizationApproval";
// SV4 Card Pages
import Sv4CardList from "../pages/sv4Card/Sv4CardList";
import Sv4CardCreate from "../pages/sv4Card/Sv4CardCreate";
import Sv4CardDetail from "../pages/sv4Card/Sv4CardDetail";
import Sv4CardApproval from "../pages/sv4Card/Sv4CardApproval";
// Self Transfer Pages
import SelfTransferList from "../pages/selfTransfer/SelfTransferList";
import SelfTransferCreate from "../pages/selfTransfer/SelfTransferCreate";
import SelfTransferDetail from "../pages/selfTransfer/SelfTransferDetail";
import SelfTransferApprovers from "../pages/selfTransfer/SelfTransferApprovers";
import SelfTransferApproval from "../pages/selfTransfer/SelfTransferApproval";
// Transfer & Posting Module Hub & Sub-Views
import TransferPostingDashboard from "../pages/selfTransfer/TransferPostingDashboard";
import InternalVacancyView from "../pages/selfTransfer/InternalVacancyView";
import MutualTransferView from "../pages/selfTransfer/MutualTransferView";
import TransferCancellationView from "../pages/selfTransfer/TransferCancellationView";
import RequestForPostingView from "../pages/selfTransfer/RequestForPostingView";
import OfficeOrdersView from "../pages/selfTransfer/OfficeOrdersView";
// Leave Management Pages
import LeaveManagementList from "../pages/LeaveManagement/LeaveManagementList";
import LeaveManagementCreate from "../pages/LeaveManagement/LeaveManagementCreate";
import LeaveManagementDetails from "../pages/LeaveManagement/LeaveManagementDetails";
import LeaveManagementTeamCalendar from "../pages/LeaveManagement/LeaveManagementTeamCalendar";
import LeaveManagementTimeAccounts from "../pages/LeaveManagement/LeaveManagementTimeAccounts";
import LeaveManagementCalendar from "../pages/LeaveManagement/LeaveManagementCalendar";
import DarAppeal from "../pages/dar/DarAppeal";
import DarAppealList from "../pages/dar/DarAppealList";
import DarAppealView from "../pages/dar/DarAppealView";
import SDSuspension from "../pages/dar/SDSuspension";
import DarSuspension from "../pages/dar/DarSuspension";
import DarSuspensionView from "../pages/dar/DarSuspensionView";
import DarRoleManagement from "../pages/dar/DarRoleManagement";
import EseprationOverview from "../pages/eSepration/EseprationOverview";
import IntimationResignation from "../pages/eSepration/IntimationResignation";
import ShortNotice from "../pages/eSepration/shortNotice";
import EseprationHub from "../pages/eSepration/EseprationHub";
import WithdrawalResignation from "../pages/eSepration/WithdrawalResignation";
import BondWaiver from "../pages/eSepration/BondWaiver";
import NoDuesTracker from "../pages/eSepration/NoDuesTracker";
import FinalDetails from "../pages/eSepration/FinalDetails";
import ESeparationProfile from "../pages/eSepration/EmployeeProfile";
import PendingApprovals from "../pages/eSepration/PendingApprovals";
import ApprovalDetail from "../pages/eSepration/ApprovalDetail";
import HRVerification from "../pages/eSepration/HRVerification";
import HRVerificationDetail from "../pages/eSepration/HRVerificationDetail";
import HrInitiateCase from "../pages/eSepration/HrInitiateCase";
import HrInitiatedCases from "../pages/eSepration/HrInitiatedCases";
import NoDuesInitiate from "../pages/eSepration/NoDuesInitiate";
import NoDuesCaseInitiate from "../pages/eSepration/NoDuesCaseInitiate";
import NoDuesCaseDetail from "../pages/eSepration/NoDuesCaseDetail";
import NoDuesFormView from "../pages/eSepration/NoDuesFormView";
import NoDuesHRReview from "../pages/eSepration/NoDuesHRReview";
import NoDuesHRReviewDetail from "../pages/eSepration/NoDuesHRReviewDetail";
import NodalAction from "../pages/eSepration/NodalAction";
import VigilanceClearancePage from "../pages/eSepration/VigilanceClearance";
import FinanceClearance from "../pages/eSepration/FinanceClearance";
import NoDuesForm from "../pages/eSepration/NoDuesForm";
import NoDuesDispatch from "../pages/eSepration/NoDuesDispatch";
import NoDuesDeptClearance from "../pages/eSepration/NoDuesDeptClearance";
import NoDuesDeptAction from "../pages/eSepration/NoDuesDeptAction";
import NoDuesSettlementInbox from "../pages/eSepration/NoDuesSettlementInbox";
import NoDuesSettlementAction from "../pages/eSepration/NoDuesSettlementAction";
import NoDuesApproverReview from "../pages/eSepration/NoDuesApproverReview";
import NoDuesDepartmentConfig from "../pages/eSepration/NoDuesDepartmentConfig";
import BondTypeConfig from "../pages/eSepration/BondTypeConfig";
import VigilanceConfig from "../pages/eSepration/VigilanceConfig";
import MedicalAttendanceApproval from "../pages/universalWorklist/MedicalAttendanceApproval";
import LeaveEncashmentApproval from "../pages/universalWorklist/LeaveEncashmentApproval";
import HallBookingApproval from "../pages/universalWorklist/HallBookingApproval";
import StaffWelfareApproval from "../pages/universalWorklist/StaffWelfareApproval";
import EAttestationApproval from "../pages/universalWorklist/EAttestationApproval";
import ReimbursementViewDetails from "../pages/reimbursement/ReimbursementViewDetails";
import BirthdayAnniversaries from "../pages/employeeBirthdayAnniversaries/BirthdayAnniversaries";
import PublicHolidays from "../pages/employeeBirthdayAnniversaries/PublicHolidays";
import DataSync from "../pages/administration/DataSync";
import ReimbursementSync from "../pages/administration/ReimbursementSync";
import VacationDetails from "../pages/staffQuarter/operations/VacationDetails";
// APAR Module Routes
import EmployeeAppraisal from "../pages/apar/EmployeeAppraisal";
import APARDownload from "../pages/apar/APARDownload";
import APARTeamStatus from "../pages/apar/APARTeamStatus";
import APARViewDetails from "../pages/apar/APARViewDetails";
import Channel from "../pages/apar/Channel";
import AppraisalDocumentList from "../pages/apar/AppraisalDocumentList";
import AppraisalDocumentDetails from "../pages/apar/AppraisalDocumentDetails";

const AdminDashboard = lazy(() => import("../mainMenu/adminDashboard"));
const EmployeeDashboard = lazy(() => import("../pages/employeeDashboard/employee-dashboard"));

// import ReimbursementCreate from "../pages/reimbursement/reimbursementCreate";


const routes = all_routes;

export const publicRoutes = [
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: routes.officeLocationMap,
    element: <OfficeLocationMap />,
  },
  {
    path: routes.userManual,
    element: <UserManual />,
  },
  {
    path: "/user-manuals",
    element: <UserManual />,
  },
  {
    path: "/help-manual",
    element: <UserManual />,
  },
  {
    path: routes.introVideo,
    element: <IntroVideo />,
  },
  {
    path: "/introduction-video",
    element: <IntroVideo />,
  },
  {
    path: "/promo-video",
    element: <IntroVideo />,
  },
];


export const adminRoutes = [
  {
    path: routes.vpf.list,
    element: <VpfList />,
  },
  {
    path: routes.reimbursementAdmin,
    element: <ReimbursementList />,
  },
  {
    path: routes.idCard.adminList,
    element: <IdCardList />,
  },
  {
    path: routes.eOffice,
    element: <EOfficeList />,
  },
  {
    path: routes.adminChangePassword,
    element: <AdminChangePassword />,
  },
  {
    path: routes.otpLogs,
    element: <OtpLogs />,
  },
  {
    path: routes.nocSapLogs,
    element: <NocSapLogs />,
  },
  {
    path: routes.hrmsApiLogs,
    element: <HrmsApiLogs />,
  },



  {
    path: routes.attendanceSummary,
    element: <AttendanceSummary />,
  },
  {
    path: routes.rolesPermissions,
    element: <RolesPermissions />,
  },
  {
    path: routes.adminUsers,
    element: <AdminUsersList />,
  },
  {
    path: routes.findAllDepartment,
    element: <FindAllDepartment />,
  },
  {
    path: routes.findAllDesignation,
    element: <FindAllDesignations />,
  },
  {
    path: routes.adminWorkSchedule,
    element: <WorkSchedule />,
  },
  {
    path: routes.workShift,
    element: <WorkShifts />,
  },
  {
    path: routes.holidaysCalendar,
    element: <HolidaysCalendar />,
  },
  {
    path: routes.rolesPermissions,
    element: <RolesPermissions />,
  },
  {
    path: "/",
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.officeLocation.list,
    element: <OfficeLocationsList />,
    route: Route,
  },
  {
    path: routes.officeLocation.add,
    element: <AddOfficeLocation />,
    route: Route,
  },
  {
    path: routes.officeLocation.edit,
    element: <AddOfficeLocation />,
    route: Route,
  },
  {
    path: routes.masterBeacon.list,
    element: <MasterBeaconList />,
    route: Route,
  },
  {
    path: routes.masters.dnarList,
    element: <DnrList />,
  },
  {
    path: routes.masters.courseDepartmentList,
    element: <CourseDepartment />,
  },
  {
    path: routes.masterBeacon.add,
    element: <AddMasterBeacon />,
    route: Route,
  },
  {
    path: routes.masterBeacon.edit,
    element: <AddMasterBeacon />,
    route: Route,
  },
  {
    path: routes.employees.list,
    element: <EmployeesList />,
    route: Route,
  },
  {
    path: routes.employees.profile_reasons,
    element: <ProfileReasons />,
    route: Route,
  },
  {
    path: routes.employees.profile,
    element: <EmployeeProfile />,
    route: Route,
  },
  {
    path: routes.language.list,
    element: <LanguageList />,
    route: Route,
  },
  {
    path: routes.language.updateString,
    element: <LanguagePhrasePage />,
    route: Route,
  },
  {
    path: routes.chatbot.list,
    element: <Intent />,
    route: Route,
  },
  {
    path: routes.chatbot.chat,
    element: <ChatInterface />,
    route: Route,
  },
  // {
  //   path: routes.settings.sms,
  //   element: <SMSSettings />,
  //   route: Route,
  // },
  // {
  //   path: routes.settings.app,
  //   element: <AppSettings />,
  //   route: Route,
  // },
  // {
  //   path: routes.settings.notification,
  //   element: <Notification />,
  //   route: Route,
  // },
  // {
  //   path: routes.settings.cache,
  //   element: <CacheSettings />,
  //   route: Route,
  // },
  // {
  //   path: routes.settings.email,
  //   element: <EmailSettings />,
  //   route: Route,
  // },
  {
    path: routes.announcements.list,
    element: <AnnouncementList />,
    route: Route,
  },
  {
    path: routes.eAttestation.master,
    element: <EAttestationMaster />,
    route: Route,
  },
  {
    path: routes.eAttestation.approver,
    element: <EAttestationApprover />,
    route: Route,
  },
  {
    path: routes.settings.sms,
    element: <AdminSettings type="sms" />,
    route: Route,
  },
  {
    path: routes.settings.general,
    element: <AdminSettings type="general" />,
  },
  {
    path: routes.settings.configVars,
    element: <AdminSettings type="configVars" />,
  },
  {
    path: routes.settings.app,
    element: <AdminSettings type="app" />,
  },
  {
    path: routes.settings.modules,
    element: <AdminSettings type="modules" />,
  },
  {
    path: routes.settings.email,
    element: <AdminSettings type="smtp" />,
  },
  {
    path: routes.settings.sms,
    element: <AdminSettings type="sms" />,
  },
  {
    path: routes.settings.notification,
    element: <AdminSettings type="notification" />,
  },
  {
    path: routes.settings.storage,
    element: <AdminSettings type="storage" />,
  },
  {
    path: routes.settings.esepHrWing,
    element: <EsepHrWingSettings />,
    route: Route,
  },
  {
    path: routes.settings.esepHrLevelConfig,
    element: <EsepHrLevelConfigSettings />,
    route: Route,
  },

  {
    path: routes.settings.errorList,
    element: <ErrorList />,
    route: Route,
  },
  {
    path: routes.logs.loginLogs,
    element: <LoginLogs />,
    route: Route,
  },
  {
    path: routes.templates.smsTemplates,
    element: <SMSTemplates />,
    route: Route,
  },
  {
    path: routes.templates.emailTemplates,
    element: <EmailTemplates />,
    route: Route,
  },
  {
    path: routes.settings.leave.leaveType,
    element: <LeaveType />,
    route: Route,
  },
  {
    path: routes.masters.natureOfDuty,
    element: <OutsideJobNature />,
    route: Route,
  },
  {
    path: routes.masters.listStays,
    element: <StayMaster />,
    route: Route,
  },
  {
    path: routes.masters.listStatuses,
    element: <SapMasterStatus />,
    route: Route,
  },
  {
    path: routes.masters.listNocTravel,
    element: <NocTravelMaster />,
    route: Route,
  },
  {
    path: routes.masters.listNatures,
    element: <JobNatures />,
    route: Route,
  },
  {
    path: routes.settings.global,
    element: <GlobalSettings />,
    route: Route,
  },
  {
    path: routes.settings.language,
    element: <LanguageSettings />,
    route: Route,
  },
  {
    path: routes.settings.pusher,
    element: <PusherSettings />,
    route: Route,
  },
  {
    path: routes.settings.recaptcha,
    element: <RecaptchaSettings />,
    route: Route,
  },
  {
    path: routes.settings.storage,
    element: <StorageSettings />,
    route: Route,
  },
  {
    path: routes.masters.wingDesignationDepartment,
    element: <WingDesignationDepartment />,
    route: Route,
  },
  {
    path: routes.masters.listCaste,
    element: <CasteMaster />,
    route: Route,
  },
  {
    path: routes.masters.listCourseCategories,
    element: <CourseCategoriesMaster />,
    route: Route,
  },
  {
    path: routes.masters.listCourseTypes,
    element: <CourseTypesMaster />,
    route: Route,
  },
  {
    path: routes.masters.listDocUploadTypes,
    element: <DocUploadTypesMaster />,
    route: Route,
  },
  {
    path: routes.masters.listModesOfCourse,
    element: <ModesOfCourseMaster />,
    route: Route,
  },
  {
    path: routes.auditLogs,
    element: <AuditLogs />,
    route: Route,
  },
  {
    path: routes.adminActivityLogs,
    element: <AdminActivityLogs />,
    route: Route,
  },
  {
    path: routes.dataSync,
    element: <DataSync />,
    route: Route,
  },
  {
    path: routes.reimbursementSync,
    element: <ReimbursementSync />,
    route: Route,
  },
  {
    path: routes.adminManagerSelfService,
    element: <AdminManagerSelfService />,
    route: Route,
  },
  // Staff Quarter Admin routes moved to employeeRoutes (Management Services)
];

export const employeeRoutes = [
  {
    path: routes.vpf.list,
    element: <VpfList />,
  },
  {
    path: routes.workShiftVerification,
    element: <ShiftVerificationList />,
    route: Route,
  },
  {
    path: routes.reportingEmployees,
    element: <ReportingEmployees />,
    route: Route,
  },
  {
    path: routes.reportingEmployeesDailyAttendence,
    element: <ReportingEmployeesDailyAttendence />,
    route: Route,
  },
  {
    path: routes.reportingEmployeeAttendance,
    element: <ReportingAttendence />,
    route: Route,
  },
  {
    path: routes.faceData,
    element: <FaceVerificationList />,
    route: Route,
  },
  {
    path: routes.employeeFaceData,
    element: <EmployeeFaceVerificationList />,
    route: Route,
  },
  {
    path: routes.employeeAttendenceRegularize,
    element: <EmployeeAttendenceRegularize />,
    route: Route,
  },
  {
    path: routes.employeeDailyAttendence,
    element: <EmployeesDailyAttendance />,
    route: Route,
  },
  {
    path: routes.employees.officeLocation,
    element: <LeaveManagment />,
    route: Route,
  },
  {
    path: routes.toDoList,
    element: <ToDoWorklistMain />,
    route: Route,
  },
  {
    path: routes.services.list,
    element: <Services />,
    route: Route,
  },
  {
    path: routes.staffQuarter.list,
    element: <StaffQuarterRequests />,
    route: Route,
  },
  {
    path: routes.staffQuarter.overview,
    element: <Overview />,
    route: Route,
  },
  {
    path: routes.staffQuarter.newRegistration,
    element: <NewRegistration />,
    route: Route,
  },
  {
    path: routes.staffQuarter.occupation,
    element: <OccupationWithdrawal />,
    route: Route,
  },
  {
    path: routes.staffQuarter.withdrawal,
    element: <OccupationWithdrawal />,
    route: Route,
  },
  {
    path: routes.staffQuarter.vacationIntimation,
    element: <VacationIntimation />,
    route: Route,
  },
  {
    path: routes.staffQuarter.requestVacation,
    element: <VacationIntimation />,
    route: Route,
  },
  {
    path: routes.staffQuarter.vacationIntimationForm,
    element: <VacationIntimationForm />,
    route: Route,
  },
  {
    path: routes.staffQuarter.myAllotments,
    element: <MyAllotments />,
    route: Route,
  },
  {
    path: routes.staffQuarter.priorityList,
    element: <EmployeePriorityList />,
    route: Route,
  },
  {
    path: routes.staffQuarter.unwillingness,
    element: <Unwillingness />,
    route: Route,
  },
  {
    path: routes.staffQuarter.mutualExchange,
    element: <MutualExchange />,
    route: Route,
  },
  {
    path: routes.staffQuarter.details,
    element: <StaffQuarterDetails />,
    route: Route,
  },
  {
    path: routes.staffQuarter.vacationDetails,
    element: <VacationDetails />,
    route: Route,
  },
  // Inventory Routes (Restored)
  {
    path: routes.staffQuarter.inventory.dashboard,
    element: <InventoryDashboard />,
    route: Route,
  },
  {
    path: routes.staffQuarter.inventory.master,
    element: <FlatMaster />,
    route: Route,
  },
  {
    path: routes.staffQuarter.inventory.vacation,
    element: <VacationInitiation />,
    route: Route,
  },
  {
    path: routes.staffQuarter.inventory.history,
    element: <InventoryHistory />,
    route: Route,
  },
  {
    path: routes.staffQuarter.inventory.locations,
    element: <InventoryLocationBreakdown />,
    route: Route,
  },
  {
    path: routes.staffQuarter.inventory.locationView,
    element: <LocationFlatView />,
    route: Route,
  },
  // Admin Management Routes for Employees
  {
    path: routes.staffQuarter.management.overview,
    element: <AdminOverview />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.requests,
    element: <AdminRequests />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.requestDetails,
    element: <StaffQuarterRequestDetails />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.houses,
    element: <HouseInventory />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.allotments,
    element: <AdminRequests />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.priorityList,
    element: <PriorityList />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.reports,
    element: <Reports />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.willingnessInvited,
    element: <WillingnessInvitedReport />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.coDashboard,
    element: <COOverview />,
    route: Route,
  },
  {
    path: routes.staffQuarterAdmin.vacationDetails,
    element: <VacationDetails />,
    route: Route,
  },
  {
    path: routes.settings.staffQuarterApproval,
    element: <StaffQuarterApprovalSettings />,
    route: Route,
  },
  {
    path: routes.staffQuarterAdmin.changeApprover,
    element: <ChangeCurrentApprover />,
    route: Route,
  },
  {
    path: routes.settings.staffQuarterChangeApprover,
    element: <ChangeCurrentApprover />,
    route: Route,
  },
  {
    path: routes.staffQuarterAdmin.letterTemplates,
    element: <LetterTemplates />,
    route: Route,
  },
  {
    path: routes.staffQuarter.management.letterTemplates,
    element: <LetterTemplates />,
    route: Route,
  },
  {
    path: routes.staffQuarterAdmin.mutualExchange,
    element: <AdminMutualExchange />,
    route: Route,
  },
  // Post-Promotional routes
  {
    path: routes.PostPromotion.list,
    element: <PromotionList />,
    route: Route,
  },
  {
    path: routes.PostPromotion.overview,
    element: <PostPromotion />,
    route: Route,
  },
  {
    path: routes.PostPromotion.ProbationConfirmation,
    element: <ProbationConfirmation />,
    route: Route,
  },
  {
    path: routes.PostPromotion.newRegistration,
    element: <NewPromotionCycle />,
    route: Route,
  },
  {
    path: routes.PostPromotion.occupation,
    element: <PostPromotion />,
    route: Route,
  },
  {
    path: routes.PostPromotion.withdrawal,
    element: <PostPromotion />,
    route: Route,
  },
  {
    path: routes.PostPromotion.vacationIntimation,
    element: <PostPromotion />,
    route: Route,
  },
  {
    path: routes.PostPromotion.OfficeOrders,
    element: <OfficeOrders />,
    route: Route,
  },
  {
    path: routes.PostPromotion.sapSyncLog,
    element: <SapSyncLog />,
    route: Route,
  },
  {
    path: routes.PostPromotion.DpcApprovalList,
    element: <DpcApprovalList />,
    route: Route,
  },
  {
    path: routes.PostPromotion.DpcReview,
    element: <DpcReview />,
    route: Route,
  },
  // Probation/Confirmation routes
  {
    path: routes.probation.dashboard,
    element: <ProbationCandidatesList />,
    route: Route,
  },
  {
    path: routes.probation.newCycle,
    element: <NewProbationCycle />,
    route: Route,
  },
  {
    path: routes.probation.cyclesDashboard,
    element: <ProbationDashboard />,
    route: Route,
  },
  {
    path: routes.probation.committeeReview,
    element: <ProbationCommitteeReview />,
    route: Route,
  },
  {
    path: routes.probation.approvalList,
    element: <ProbationApprovalList />,
    route: Route,
  },
  {
    path: routes.probation.officeOrders,
    element: <ProbationOfficeOrders />,
    route: Route,
  },
  {
    path: routes.darCase.overview,
    element: <DarDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.new,
    element: <DarContemplated />,
    route: Route,
  },
  {
    path: routes.darCase.contemplated,
    element: <DarContemplatedList />,
    route: Route,
  },
  {
    path: routes.darCase.pending,
    element: <DarPendingList />,
    route: Route,
  },
  {
    path: routes.darCase.pendingForm,
    element: <DarPending />,
    route: Route,
  },
  {
    path: routes.darCase.pendingDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.closed,
    element: <DarClosedList />,
    route: Route,
  },
  {
    path: routes.darCase.closedForm,
    element: <DarClosed />,
    route: Route,
  },
  {
    path: routes.darCase.closedDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.details,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.appealAgainstPenalty,
    element: <DarAppealList />,
    route: Route,
  },
  {
    path: routes.darCase.appealForm,
    element: <DarAppeal />,
    route: Route,
  },
  {
    path: routes.darCase.appealDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.sdSuspension,
    element: <SDSuspension />,
    route: Route,
  },
  {
    path: routes.location.list,
    element: <LeaveManagment />,
    route: Route,
  },
  {
    path: routes.reportingEmployeeShift,
    element: <ReportingShift />,
    route: Route,
  },
  {
    path: routes.teamShiftOverview,
    element: <TeamShiftHistory />,
    route: Route,
  },
  {
    path: routes.employeeSetting,
    element: <SettingsPage />,
    route: Route,
  },

  {
    path: routes.employees.verifications,
    element: <EmployeesVerificationList />,
    route: Route,
  },
  {
    path: routes.birthdayAnniversaries,
    element: <BirthdayAnniversaries />,
    route: Route,
  },
  {
    path: routes.publicHolidays,
    element: <PublicHolidays />,
    route: Route,
  },
  {
    path: routes.policeVerification,
    element: <PoliceVerification />,
    route: Route,
  },
  {
    path: routes.reimbursementSync,
    element: <ReimbursementSync />,
    route: Route,
  },
  // Ensure DAR routes are available for employee layout to avoid full page reloads
  {
    path: routes.darCase.overview,
    element: <DarDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.contemplated,
    element: <DarContemplatedList />,
    route: Route,
  },
  {
    path: routes.darCase.pending,
    element: <DarPendingList />,
    route: Route,
  },
  {
    path: routes.darCase.pendingForm,
    element: <DarPending />,
    route: Route,
  },
  {
    path: routes.darCase.pendingDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.closed,
    element: <DarClosedList />,
    route: Route,
  },
  {
    path: routes.darCase.closedForm,
    element: <DarClosed />,
    route: Route,
  },
  {
    path: routes.darCase.closedDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.details,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.appealAgainstPenalty,
    element: <DarAppealList />,
    route: Route,
  },
  {
    path: routes.darCase.appealForm,
    element: <DarAppeal />,
    route: Route,
  },
  {
    path: routes.darCase.appealDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.sdSuspension,
    element: <SDSuspension />,
    route: Route,
  },
  {
    path: routes.Esepration.hub,
    element: <EseprationHub />,
    route: Route,
  },
  {
    path: routes.darCase.sdSuspensionForm,
    element: <DarSuspension />,
    route: Route,
  },
  {
    path: routes.darCase.sdSuspensionDetails,
    element: <DarCaseDetailsDashboard />,
    route: Route,
  },
  {
    path: routes.darCase.roleManagement,
    element: <DarRoleManagement />,
    route: Route,
  },
  {
    path: routes.Esepration.switchUser,
    element: <Esepration />,
    route: Route,
  },
  {
    path: routes.Esepration.overview,
    element: <EseprationOverview />,
    route: Route,
  },
  {
    path: routes.Esepration.intimationResignation,
    element: <IntimationResignation />,
    route: Route,
  },
  {
    path: routes.Esepration.shortNotice,
    element: <ShortNotice />,
    route: Route,
  },
  {
    path: routes.Esepration.withdrawal,
    element: <WithdrawalResignation />,
    route: Route,
  },
  {
    path: routes.Esepration.bondWaiver,
    element: <BondWaiver />,
    route: Route,
  },
  {
    path: routes.Esepration.noDues,
    element: <NoDuesTracker />,
    route: Route,
  },
  {
    path: routes.Esepration.finalDetails,
    element: <FinalDetails />,
    route: Route,
  },
  {
    path: routes.Esepration.profile,
    element: <ESeparationProfile />,
    route: Route,
  },
  {
    path: routes.Esepration.approvals,
    element: <PendingApprovals />,
    route: Route,
  },
  {
    path: routes.Esepration.approvalDetail,
    element: <ApprovalDetail />,
    route: Route,
  },
  {
    path: routes.Esepration.hrVerification,
    element: <HRVerification />,
    route: Route,
  },
  {
    path: routes.Esepration.hrVerificationDetail,
    element: <HRVerificationDetail />,
    route: Route,
  },
  {
    path: routes.Esepration.hrInitiateCase,
    element: <HrInitiateCase />,
    route: Route,
  },
  {
    path: routes.Esepration.hrInitiatedCases,
    element: <HrInitiatedCases />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesInitiate,
    element: <NoDuesInitiate />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesCaseInitiate,
    element: <NoDuesCaseInitiate />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesCaseDetail,
    element: <NoDuesCaseDetail />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesHrReview,
    element: <NoDuesHRReview />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesHrReviewDetail,
    element: <NoDuesHRReviewDetail />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesNodal,
    element: <NodalAction />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesVigilance,
    element: <VigilanceClearancePage />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesFinance,
    element: <FinanceClearance />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesForm,
    element: <NoDuesForm />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesDispatch,
    element: <NoDuesDispatch />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesDeptClearance,
    element: <NoDuesDeptClearance />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesDeptAction,
    element: <NoDuesDeptAction />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesDeptActionDetail,
    element: <NoDuesDeptAction />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesApproverReview,
    element: <NoDuesApproverReview />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesApproverReviewDetail,
    element: <NoDuesApproverReview />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesDeptConfig,
    element: <NoDuesDepartmentConfig />,
    route: Route,
  },
  {
    path: routes.Esepration.bondTypeConfig,
    element: <BondTypeConfig />,
    route: Route,
  },
  {
    path: routes.Esepration.vigilanceConfig,
    element: <VigilanceConfig />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesSettlementInbox,
    element: <NoDuesSettlementInbox />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesSettlementAction,
    element: <NoDuesSettlementAction />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesSettlementActionDetail,
    element: <NoDuesSettlementAction />,
    route: Route,
  },
  {
    path: routes.Esepration.noDuesFormView,
    element: <NoDuesFormView />,
    route: Route,
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />,
    route: Route,
  },
  {
    path: routes.universalWorklist,
    element: <UniversalWorklist />,
    route: Route,
  },
  {
    path: "/todo-worklist/universal-worklist",
    element: <TasksPage />,
    route: Route,
  },
  // To-Do Worklist Routes
  {
    path: routes.todoWorklist.main,
    element: <ToDoWorklistMain />,
    route: Route,
  },
  {
    path: routes.todoWorklist.tasks,
    element: <TasksPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.tasksMobile,
    element: <TasksPageMobile />,
    route: Route,
  },
  {
    path: routes.todoWorklist.taskDetails,
    element: <TaskDetailsPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.nocTaskDetails,
    element: <TaskDetailsPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.leaveApprovalDetail,
    element: <LeaveApprovalDetailPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.leaveApprovalPage,
    element: <LeaveApprovalPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.nocApprovalDetail,
    element: <NOCApprovalDetailPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.reimbursementApprovalDetail,
    element: <ReimbursementApprovalDetailPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.itDeclarationApprovalDetail,
    element: <ITDeclarationApprovalDetailPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.alerts,
    element: <AlertsPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.notifications,
    element: <NotificationsPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.officeMails,
    element: <OfficeMailsPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.tracking,
    element: <TrackingPage />,
    route: Route,
  },
  {
    path: routes.todoWorklist.idCardApprovalDetail,
    element: <IDCardApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.medicalAttendanceApproval,
    element: <MedicalAttendanceApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.leaveEncashmentApproval,
    element: <LeaveEncashmentApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.hallBookingApproval,
    element: <HallBookingApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.staffWelfareApproval,
    element: <StaffWelfareApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.eAttestationApproval,
    element: <EAttestationApproval />,
    route: Route,
  },
  {
    path: routes.notification,
    element: <Notification />,
    route: Route,
  },
  {
    path: routes.myprofile,
    element: <MyProfile />,
    route: Route,
  },
  {
    path: routes.attendance.list,
    element: <EmployeesAttendanceList />,
    route: Route,
  },
  {
    path: routes.services.list,
    element: <Services />,
    route: Route,
  },
  {
    path: routes.leave.list,
    element: <LeaveManagment />,
    route: Route,
  },
  {
    path: routes.leave.details,
    element: <LeaveDetailsPage />,
    route: Route,
  },
  {
    path: routes.leave.create,
    element: <CreateLeaveRequest />,
    route: Route,
  },
  {
    path: routes.changePassword,
    element: <ChangePassword />,
    route: Route,
  },
  {
    path: routes.myProfile,
    element: <MyProfile />,
    route: Route,
  },
  {
    path: routes.adminProfile,
    element: <AdminProfile />,
    route: Route,
  },
  {
    path: routes.adminMyProfile,
    element: <AdminProfile />,
    route: Route,
  },
  {
    path: routes.employeeWorkSchedule,
    element: <EmployeeWorkSchedule />,
    route: Route,
  },
  // NOC Routes
  {
    path: routes.noc.main,
    element: <NOCMain />,
    route: Route,
  },
  {
    path: routes.noc.outsideJob,
    element: <NOCOutsideJob />,
    route: Route,
  },
  {
    path: `${routes.noc.outsideJob}/create`,
    element: <NOCOutsideJobCreateForm />,
    route: Route,
  },
  {
    path: `${routes.noc.outsideJob}/details/:id`,
    element: <NOCOutsideJobDetails />,
    route: Route,
  },
  {
    path: `${routes.noc.outsideJob}/edit/:id`,
    element: <NOCOutsideJobCreateForm />,
    route: Route,
  },
  {
    path: routes.noc.passport,
    element: <NOCPassport />,
    route: Route,
  },
  {
    path: `${routes.noc.passport}/create`,
    element: <PassportCreate />,
    route: Route,
  },
  {
    path: `${routes.noc.passport}/details/:id`,
    element: <NOCPassportDetails />,
    route: Route,
  },
  {
    path: `${routes.noc.passport}/edit/:id`,
    element: <PassportCreate />,
    route: Route,
  },
  {
    path: routes.noc.higherEducation,
    element: <NOCHigherEducation />,
    route: Route,
  },
  {
    path: routes.noc.higherEducationCreate,
    element: <NOCHigherStudiesForm />,
    route: Route,
  },
  {
    path: routes.noc.higherEducationEdit,
    element: <NOCHigherStudiesForm />,
    route: Route,
  },
  {
    path: routes.noc.higherEducationDetails,
    element: <NOCHigherEducationDetails />,
    route: Route,
  },
  {
    path: routes.noc.foreignVisit,
    element: <NOCForeignVisit />,
    route: Route,
  },
  {
    path: `${routes.noc.foreignVisit}/create`,
    element: <ForeignVisitCreate />,
    route: Route,
  },
  {
    path: `${routes.noc.foreignVisit}/edit/:id`,
    element: <ForeignVisitCreate />, // Using same component for edit mode
    route: Route,
  },
  {
    path: `${routes.noc.foreignVisit}/details/:id`,
    element: <ForeignVisitDetails />,
    route: Route,
  },
  {
    path: routes.noc.onlineCourse,
    element: <NOCOnlineCourse />,
    route: Route,
  },
  {
    path: `${routes.noc.onlineCourse}/create`,
    element: <NOCOnlineCourseCreate />,
    route: Route,
  },
  {
    path: `${routes.noc.onlineCourse}/details/:id`,
    element: <NOCOnlineCourseDetails />,
    route: Route,
  },
  {
    path: `${routes.noc.onlineCourse}/edit/:id`,
    element: <NOCOnlineCourseCreate />,
    route: Route,
  },
  {
    path: `${routes.noc.onlineCourse}/create-reimbursement/:id`,
    element: <NOCOnlineCourseReimbursement />,
    route: Route,
  },
  {
    path: `${routes.noc.onlineCourse}/reimbursement-details/:id`,
    element: <NOCOnlineCourseReimbursementDetails />,
    route: Route,
  },
  {
    path: routes.whoIsWho,
    element: <WhoIsWho />,
    route: Route,
  },
  {
    path: routes.salaryStatement,
    element: <SalaryStatement />,
    route: Route,
  },
  {
    path: routes.salaryStatementHindi,
    element: <SalaryStatementHindi />,
    route: Route,
  },
  {
    path: routes.salaryStatementEnglish,
    element: <SalaryStatementEnglish />,
    route: Route,
  },
  {
    path: routes.multipleSalaryStatement,
    element: <MultipleSalaryStatement />,
    route: Route,
  },
  {
    path: routes.annualPropertyReturn,
    element: <AnnualPropertyReturn />,
    route: Route,
  },
  {
    path: routes.dueDrawn,
    element: <DueDrawn />,
    route: Route,
  },
  {
    path: routes.policeVerification,
    element: <PoliceVerification />,
    route: Route,
  },
  {
    path: routes.displayTaxCard,
    element: <DisplayTaxCard />,
    route: Route,
  },
  {
    path: routes.taxSimplifier,
    element: <TaxSimplifier />,
    route: Route,
  },
  {
    path: routes.taxSimplifierDetails,
    element: <TaxSimplifierDetails />,
    route: Route,
  },
  {
    path: routes.taxSimplifierEdit,
    element: <TaxDeclarationEdit />,
    route: Route,
  },
  {
    path: routes.loanSurety,
    element: <LoanSuretySelection />,
    route: Route,
  },
  {
    path: routes.loanSuretyStatus,
    element: <LoanSuretyStatus />,
    route: Route,
  },
  {
    path: routes.managerSelfService,
    element: <ManagerSelfService />,
    route: Route,
  },
  {
    path: routes.annualNps,
    element: <AnnualNps />,
    route: Route,
  },
  {
    path: routes.annualPf,
    element: <AnnualPf />,
    route: Route,
  },
  {
    path: routes.vpfModule.list,
    element: <VPFContributionModule />,
    route: Route,
  },
  {
    path: routes.vpfModule.details,
    element: <VpfDisplay />,
    route: Route,
  },
  {
    path: routes.appealContribution.list,
    element: <AppealContributionList />,
    route: Route,
  },
  {
    path: routes.appealContribution.create,
    element: <CreateAppealContribution />,
    route: Route,
  },
  {
    path: routes.appealContribution.details,
    element: <AppealContributionDetails />,
    route: Route,
  },
  {
    path: routes.leaveEncashment.list,
    element: <LeaveEncashmentList />,
    route: Route,
  },
  {
    path: routes.leaveEncashment.create,
    element: <CreateLeaveEncashment />,
    route: Route,
  },
  {
    path: routes.leaveEncashment.review,
    element: <ReviewLeaveEncashment />,
    route: Route,
  },
  {
    path: routes.leaveEncashment.details,
    element: <LeaveEncashmentDetail />,
    route: Route,
  },
  {
    path: routes.communityHall.list,
    element: <CommunityHallList />,
    route: Route,
  },
  {
    path: routes.communityHall.create,
    element: <CreateCommunityHallBooking />,
    route: Route,
  },
  {
    path: routes.communityHall.view,
    element: <ViewCommunityHallBooking />,
    route: Route,
  },
  {
    path: routes.communityHall.overview,
    element: <CommunityHallBookingOverview />,
    route: Route,
  },
  {
    path: routes.medicalAttendance.list,
    element: <MedicalAttendanceList />,
    route: Route,
  },
  {
    path: routes.medicalAttendance.create,
    element: <CreateMedicalAttendance />,
    route: Route,
  },
  {
    path: routes.medicalAttendance.view,
    element: <ViewMedicalAttendance />,
    route: Route,
  },
  {
    path: routes.medicalAttendance.details,
    element: <DisplayMedicalAttendance />,
    route: Route,
  },
  {
    path: routes.authorityLetterHealthCheckup.list,
    element: <AuthorityLetterList />,
    route: Route,
  },
  {
    path: routes.authorityLetterHealthCheckup.create,
    element: <CreateAuthorityLetter />,
    route: Route,
  },
  {
    path: routes.authorityLetterHealthCheckup.view,
    element: <ViewAuthorityLetter />,
    route: Route,
  },
  {
    path: routes.authorityLetterHealthCheckup.details,
    element: <DisplayAuthorityLetter />,
    route: Route,
  },
  {
    path: routes.staffWelfareFund.list,
    element: <StaffWelfareList />,
    route: Route,
  },
  {
    path: routes.eAttestation.list,
    element: <EAttestationList />,
    route: Route,
  },
  {
    path: routes.eAttestation.create,
    element: <EAttestationForm />,
    route: Route,
  },
  {
    path: routes.eAttestation.edit,
    element: <EAttestationForm />,
    route: Route,
  },
  {
    path: routes.eAttestation.details,
    element: <EAttestationDetails />,
    route: Route,
  },
  {
    path: routes.staffWelfareFund.create,
    element: <CreateStaffWelfare />,
    route: Route,
  },
  {
    path: routes.staffWelfareFund.view,
    element: <ViewStaffWelfare />,
    route: Route,
  },
  {
    path: routes.dmrcCalendar,
    element: <DMRCCalendar />,
    route: Route,
  },
  {
    path: routes.circulars.main,
    element: <CircularsPage />,
    route: Route,
  },
  // Reimbursement
  {
    path: routes.Reimbursement.list,
    element: <ReimbursementClaimsAdvances />,
    route: Route,
  },
  {
    path: routes.Reimbursement.create,
    element: <ReimbursementCreationModal />,
    route: Route,
  },
  {
    path: routes.Reimbursement.details,
    element: <ReimbursementViewDetails />,
    route: Route,
  },
  // IT Declaration
  {
    path: routes.itDeclaration.list,
    element: <ITDeclarationList />,
    route: Route,
  },
  {
    path: routes.itDeclaration.create,
    element: <ITDeclarationCreatePage />,
    route: Route,
  },
  {
    path: routes.itDeclaration.details,
    element: <ITDeclarationDetailsPage />,
    route: Route,
  },
  {
    path: routes.reimbursementItDeclaration,
    element: <ITDeclarationList />,
    route: Route,
  },
  // id Card Identity
  {
    path: routes.idCard.list,
    element: <IDCardList />,
    route: Route,
  },
  {
    path: routes.idCard.createRequest,
    element: <IDCardForm />,
    route: Route,
  },
  {
    path: routes.idCard.inclusionOfDependent,
    element: <InclusionParentsList />,
    route: Route,
  },
  {
    path: routes.idCard.createFamilyMemberRequest,
    element: <InclusionParentsForm />,
    route: Route,
  },
  {
    path: routes.idCard.inclusionParentsView,
    element: <InclusionApprovalPage kind="parents" readOnly />,
    route: Route,
  },
  {
    path: routes.idCard.deletionOfDependent,
    element: <DeletionParentsList />,
    route: Route,
  },
  {
    path: routes.idCard.deletionOfDependent + '/create',
    element: <DeletionParentsForm />,
    route: Route,
  },
  {
    path: routes.idCard.familyMemberInclusion,
    element: <FamilyMembersList />,
    route: Route,
  },
  {
    path: routes.idCard.familyMemberCreate,
    element: <FamilyMembersForm />,
    route: Route,
  },
  {
    path: routes.todoWorklist.inclusionParentsApproval,
    element: <InclusionApprovalPage kind="parents" />,
    route: Route,
  },
  {
    path: routes.todoWorklist.inclusionDeletionApproval,
    element: <InclusionApprovalPage kind="delete" />,
    route: Route,
  },
  {
    path: routes.todoWorklist.inclusionFamilyApproval,
    element: <InclusionApprovalPage kind="family" />,
    route: Route,
  },
  // New I-Card Module Pages
  {
    path: routes.idCard.instruction,
    element: <IDCardInstruction />,
    route: Route,
  },
  {
    path: routes.idCard.requestList,
    element: <IDCardList />,
    route: Route,
  },
  {
    path: routes.idCard.form,
    element: <IDCardForm />,
    route: Route,
  },
  {
    path: routes.idCard.formEdit,
    element: <IDCardForm />,
    route: Route,
  },
  {
    path: routes.idCard.details,
    element: <IDCardDetails />,
    route: Route,
  },
  {
    path: routes.idCard.approval,
    element: <IDCardApproval />,
    route: Route,
  },
  // E-Requisition (IT)
  {
    path: routes.eRequisitionIT.list,
    element: <ERequisitionITList />,
    route: Route,
  },
  {
    path: routes.eRequisitionIT.create,
    element: <ERequisitionITCreate />,
    route: Route,
  },
  {
    path: routes.eRequisitionIT.edit,
    element: <ERequisitionITCreate />,
    route: Route,
  },
  {
    path: routes.eRequisitionIT.details,
    element: <ERequisitionITDetails />,
    route: Route,
  },
  // SAP Authorization
  {
    path: routes.sapAuthorization.list,
    element: <SapAuthorizationList />,
    route: Route,
  },
  {
    path: routes.sapAuthorization.create,
    element: <SapAuthorizationCreate />,
    route: Route,
  },
  {
    path: routes.sapAuthorization.edit,
    element: <SapAuthorizationCreate />,
    route: Route,
  },
  {
    path: routes.sapAuthorization.details,
    element: <SapAuthorizationDetails />,
    route: Route,
  },
  {
    path: routes.sapAuthorization.approval,
    element: <SapAuthorizationApproval />,
    route: Route,
  },
  // SV4 Card (Issue/Re-issue)
  {
    path: routes.sv4Card.list,
    element: <Sv4CardList />,
    route: Route,
  },
  {
    path: routes.sv4Card.create,
    element: <Sv4CardCreate />,
    route: Route,
  },
  {
    path: routes.sv4Card.details,
    element: <Sv4CardDetail />,
    route: Route,
  },
  {
    path: routes.sv4Card.approval,
    element: <Sv4CardApproval />,
    route: Route,
  },
  // Self Transfer / Transfer Posting
  // Removed hub overview screen and disabled non-self-transfer sub-modules; redirecting to Self Transfer
  {
    path: routes.transferPosting.hub,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.transferApplications,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.transferPosting.internalVacancy,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.transferPosting.mutualTransfer,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.transferPosting.cancellation,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.transferPosting.requestPosting,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.transferPosting.officeOrders,
    element: <Navigate to={routes.selfTransfer.list} replace />,
    route: Route,
  },
  {
    path: routes.selfTransfer.list,
    element: <SelfTransferList />,
    route: Route,
  },
  {
    path: routes.selfTransfer.create,
    element: <SelfTransferCreate />,
    route: Route,
  },
  {
    path: routes.selfTransfer.details,
    element: <SelfTransferDetail />,
    route: Route,
  },
  {
    path: routes.selfTransfer.approvers,
    element: <SelfTransferApprovers />,
    route: Route,
  },
  {
    path: routes.selfTransfer.approval,
    element: <SelfTransferApproval />,
    route: Route,
  },
  {
    path: routes.worklist.transferPosting,
    element: <SelfTransferList />,
    route: Route,
  },
  {
    path: routes.worklist.transferPostingApproval,
    element: <SelfTransferApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.selfTransferApproval,
    element: <SelfTransferApproval />,
    route: Route,
  },
  {
    path: routes.todoWorklist.transferPostingApproval,
    element: <SelfTransferApproval />,
    route: Route,
  },
  // Leave Management
  {
    path: routes.LeaveManagement.list,
    element: <LeaveManagementList />,
    route: Route,
  },
  {
    path: routes.LeaveManagement.create,
    element: <LeaveManagementCreate />,
    route: Route,
  },
  {
    path: routes.LeaveManagement.details,
    element: <LeaveManagementDetails />,
    route: Route,
  },
  {
    path: routes.LeaveManagement.calendar,
    element: <LeaveManagementCalendar />,
    route: Route,
  },
  {
    path: routes.LeaveManagement.teamCalendar,
    element: <LeaveManagementTeamCalendar />,
    route: Route,
  },
  {
    path: routes.LeaveManagement.timeAccounts,
    element: <LeaveManagementTimeAccounts />,
    route: Route,
  },
  // APAR
  {
    path: routes.apar.dashboard,
    element: <EmployeeAppraisal />,
    route: Route,
  },
  {
    path: routes.apar.download,
    element: <APARDownload />,
    route: Route,
  },
  {
    path: routes.apar.teamStatus,
    element: <APARTeamStatus />,
    route: Route,
  },
  {
    path: routes.apar.details,
    element: <APARViewDetails />,
    route: Route,
  },
  {
    path: routes.apar.channel,
    element: <Channel />,
    route: Route,
  },
  {
    path: routes.apar.documents,
    element: <AppraisalDocumentList />,
    route: Route,
  },
  {
    path: routes.apar.documentDetails,
    element: <AppraisalDocumentDetails />,
    route: Route,
  }
];

export const authRoutes = [
  {
    path: routes.adminLogin,
    element: <AdminLogin />,
    route: Route,
  },
  {
    path: routes.adminTwoStepVerification,
    element: <AdminTwoStepVerification />,
    route: Route,
  },
  {
    path: routes.adminForgotPassword,
    element: <AdminForgotPassword />,
    route: Route,
  },
  {
    path: routes.adminResetPassword,
    element: <AdminResetPassword />,
    route: Route,
  },
  {
    path: routes.adminVerifyOtp,
    element: <AdminVerifyOtp />,
    route: Route,
  },
  {
    path: routes.adminResetPasswordSuccess,
    element: <AdminResetPasswordSuccess />,
  },

  {
    path: routes.login,
    element: <EmployeeLogin />,
    route: Route,
  },

  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.verifyOtp,
    element: <VerifyOtp />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: "*",
    element: <Error404 />,
    route: Route,
  },
];

